import React, { useEffect, useState } from "react";

import { Row, Col, Divider, Card } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { DownOutlined, PlusOutlined } from "@ant-design/icons";
import { ADJUSTER_PWA_URL, API_URL, APP_API_URL } from "../../../constants";
import useAxios from "@use-hooks/axios";

// CSS Files
import "../../Fonts/Fonts.css";
import "../../Statics/Common/FontStyle.css";
import "../../Statics/DownloadApp/DownloadAppInside.css";

import androidIcon from "../../Imgs/DownloadApp/android.svg";
import appleIcon from "../../Imgs/DownloadApp/apple.svg";

// JS Files

const ArzyabAppMain = (props) => {
  const [links, setLinks] = useState({ arzyab_app: null });
  useEffect(() => {
    // GET request using fetch inside useEffect React hook
    fetch(`${APP_API_URL}/api/app/commons/app_link/?insurance_code=Adjuster`)
      .then((response) => response.json())
      .then((data) => setLinks(data));
  }, []);
  return props.size === "laptopdesktop" ? (
    <>
      <div className="AppArzyabBackground">
        <div style={{ paddingTop: "100px" }}>
          <Center>
            <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft">
              <strong>اپلیکیشن کارشناس اتومبیل</strong>
            </p>
          </Center>
          <Center>
            <Margin top={2}>
              <p className="mainTitleDescription" style={{ color: "#fff" }}>
                دانلود اپلیکیشن کارشناس اتومبیل شرکت ایرانیان پوشش
              </p>
            </Margin>
          </Center>
        </div>
        <Row style={{ marginTop: "100px" }}>
          <Col span={5}></Col>
          <Col span={14}>
            <div
              style={{
                opacity: "95%",
                backgroundColor: "#f9f9f9",
                borderRadius: "20px",
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                padding: "25px",
                marginBottom: "100px",
              }}
            >
              <p className="textParagraph">
                اپلیکیشن کارشناس اتومبیل با هدف ارائه خدمات بهتر در زمینه
                پرونده‌های خسارت مالی اتومبیل و دستیار کارشناسان محترم طراحی
                گردیده است. کارشناسان با دانلود این اپلیکیشن می‌توانند پرونده
                های ارسال شده از سوی CRM پورتال اتومبیل و همچنین اعلام خسارت‌های
                مشتریان را براساس موقعیت جغرافیایی مدیریت و ارزیابی نمایند.
                تسریع و تسهیل در روند ارزیابی و برآورد خسارت، کاهش تقلب، همگام
                بودن با پورتال اتومبیل و اپ‌ سپر از مزیت های این اپلیکیشن به
                شمار می رود.
              </p>
              <div className="download-app-part">
                <div
                  className="box"
                  onClick={() => window.open(ADJUSTER_PWA_URL ,"_blank")}
                >
                  <img className="icon" src={appleIcon} />
                  <div className="text">
                    <span className="main">ویژه کاربران ios</span>
                    <span className="sub">نسخه وب اپلیکیشن</span>
                  </div>
                </div>
                <div
                  className="box"
                  onClick={() => window.open(links?.arzyab_app, "_blank")}
                >
                  <img className="icon" src={androidIcon} />
                  <div className="text">
                    <span className="main">دانلود نسخه اندروید از طریق</span>
                    <span className="sub">لینک مستقیم</span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col span={5}></Col>
        </Row>
      </div>
    </>
  ) : props.size === "tablet" ? (
    <div className="AppArzyabBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft">
            <strong>اپلیکیشن کارشناس اتومبیل</strong>
          </p>
        </Center>
        <Center>
          <Margin top={2}>
            <p className="mainTitleDescriptionTablet" style={{ color: "#fff" }}>
              دانلود اپلیکیشن کارشناس اتومبیل شرکت ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "75px" }}>
        <Col span={2}></Col>
        <Col span={20}>
          <div
            style={{
              opacity: "95%",
              backgroundColor: "#f9f9f9",
              borderRadius: "20px",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              padding: "25px",
              marginBottom: "50px",
            }}
          >
            <p className="textParagraph">
              اپلیکیشن کارشناس اتومبیل با هدف ارائه خدمات بهتر در زمینه
              پرونده‌های خسارت مالی اتومبیل و دستیار کارشناسان محترم طراحی
              گردیده است. کارشناسان با دانلود این اپلیکیشن می‌توانند پرونده های
              ارسال شده از سوی CRM پورتال اتومبیل و همچنین اعلام خسارت‌های
              مشتریان را براساس موقعیت جغرافیایی مدیریت و ارزیابی نمایند. تسریع
              و تسهیل در روند ارزیابی و برآورد خسارت، کاهش تقلب، همگام بودن با
              پورتال اتومبیل و اپ‌ سپر از مزیت های این اپلیکیشن به شمار می رود.
            </p>
            <div className="download-app-part">
              <div
                className="box"
                onClick={() => window.open(ADJUSTER_PWA_URL, "_blank")}
              >
                <img className="icon" src={appleIcon} />
                <div className="text">
                  <span className="main">ویژه کاربران ios</span>
                  <span className="sub">نسخه وب اپلیکیشن</span>
                </div>
              </div>
              <div
                className="box"
                onClick={() => window.open(links?.arzyab_app, "_blank")}
              >
                <img className="icon" src={androidIcon} />
                <div className="text">
                  <span className="main">دانلود نسخه اندروید از طریق</span>
                  <span className="sub">لینک مستقیم</span>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col span={2}></Col>
      </Row>
    </div>
  ) : (
    <div className="AppArzyabBackground">
      <div style={{ paddingTop: "50px" }}>
        <Center>
          <p className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile">
            <strong>اپلیکیشن کارشناس اتومبیل</strong>
          </p>
        </Center>
        <Center>
          <Margin top={3}>
            <p className="mainTitleDescriptionMobile" style={{ color: "#fff" }}>
              دانلود اپلیکیشن کارشناس اتومبیل شرکت ایرانیان پوشش
            </p>
          </Margin>
        </Center>
      </div>
      <Row style={{ marginTop: "25px" }}>
        <Col span={1}></Col>
        <Col span={22}>
          <div
            style={{
              opacity: "95%",
              backgroundColor: "#f9f9f9",
              borderRadius: "20px",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              padding: "25px",
              marginBottom: "50px",
            }}
          >
            <p className="textParagraph">
              اپلیکیشن کارشناس اتومبیل با هدف ارائه خدمات بهتر در زمینه
              پرونده‌های خسارت مالی اتومبیل و دستیار کارشناسان محترم طراحی
              گردیده است. کارشناسان با دانلود این اپلیکیشن می‌توانند پرونده های
              ارسال شده از سوی CRM پورتال اتومبیل و همچنین اعلام خسارت‌های
              مشتریان را براساس موقعیت جغرافیایی مدیریت و ارزیابی نمایند. تسریع
              و تسهیل در روند ارزیابی و برآورد خسارت، کاهش تقلب، همگام بودن با
              پورتال اتومبیل و اپ‌ سپر از مزیت های این اپلیکیشن به شمار می رود.
            </p>
            <div className="download-app-part">
              <div
                className="box"
                onClick={() => window.open(links?.arzyab_app, "_blank")}
              >
                <img className="icon" src={androidIcon} />
                <div className="text">
                  <span className="main">دانلود نسخه اندروید از طریق</span>
                  <span className="sub">لینک مستقیم</span>
                </div>
              </div>
              <div
                className="box"
                onClick={() => window.open(ADJUSTER_PWA_URL, "_blank")}
              >
                <img className="icon" src={appleIcon} />
                <div className="text">
                  <span className="main">ویژه کاربران ios</span>
                  <span className="sub">نسخه وب اپلیکیشن</span>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col span={1}></Col>
      </Row>
    </div>
  );
};

export default ArzyabAppMain;
